<div class="restrictionCard">
  <div class="info">
    <h2 class="restrictionCard-title1 text-black line-bottom">
      معلومات الايقاف
    </h2>
    <div class="restrictionCard-label text-grey">أسباب الايقاف</div>
    <div class="restrictionCard-title1 text-black">
      {{franchiseSuspension?.reason}}
    </div>

    <div class="restrictionCard-label text-grey">المرفقات</div>
    <div class="row">
      <div class="col-lg-4 col-6">
        <div class="file-container">
          <div class="file-container-info d-flex">
            <div class="file-icon">
              <img src="./assets/images/pdf-icon.svg" />
            </div>
            <div class="file-info">
              <h6 class="file-name">{{attachment?.fileName}}</h6>
              <h6 class="file-type">{{attachment?.attachmentTypeName}}</h6>
            </div>
          </div>
          <div class="icons">
            <div
              class="icon d-flex justify-content-center align-items-center preview"
            >
              <i class="fa-light fa-eye cursor-pointer"></i>
            </div>
            <div
              class="icon d-flex justify-content-center align-items-center download"
              (click)="downloadAttachment()"
            >
              <i
                class="fa-sharp fa-regular fa-arrow-down-to-line cursor-pointer"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">حالة القيد</h2>
        <div class="restrictionCard-title1 text-black">
          <span [qcId]="'suspended-status-span'" class="badge in-active">موقوف</span>
        </div>
      </div>
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">اسم الموظف</h2>
        <div class="restrictionCard-title1 text-black">
          {{franchiseSuspension?.employeeName}}
        </div>
      </div>
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">تاريخ الايقاف</h2>
        <div class="restrictionCard-title1 text-black">{{franchiseSuspension?.createdDatetime}}</div>
      </div>
    </div>
    <hr class="border-line" />
  </div>
</div>
